import { Skeleton, Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import React from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { isListView } from '../../../../actions/toggleAction';
import { useIntl } from 'react-intl';
import { removeTaskFromProjectAction } from '../../../../redux/tasks/actions';
import ConnectedProjectSectionsDropdown from './primitive-connected-task-components/ConnectedProjectSectionsDropdown';
import ConnectedProjectTitle from './primitive-connected-task-components/ConnectedProjectTitle';
import ConnectedProjectIcon from './primitive-connected-task-components/ConnectedProjectIcon';

export const TaskCardProjects = ({ projects, taskId, setProjects, isLoading }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  return isEmpty(projects) ? null : (
    <>
      {projects?.map((prj, idx) => {
        if (isLoading) {
          return (
            <div key={prj?.projectId} className="col-span-full">
              <Skeleton
                style={{
                  borderRadius: 6,
                  marginTop: 5,
                }}
                active={true}
                paragraph={{ rows: 1, width: ['100%'] }}
                title={false}
              />
            </div>
          );
        }

        return (
          <div
            key={prj?.projectId}
            style={{
              display: 'flex',
              alignItems: 'center',
              borderBottomWidth: projects?.length - 1 === idx ? 1.25 : 0,
              borderBottomColor: projects?.length - 1 === idx ? '#E0E4E6' : 'transparent',
              borderLeftWidth: 1.25,
              borderRightWidth: 1.25,
              borderColor: '#E0E4E6',
              borderTopWidth: 1.25,
              borderTopLeftRadius: idx === 0 ? 12 : 0,
              borderTopRightRadius: idx === 0 ? 12 : 0,
              borderBottomLeftRadius: projects?.length - 1 === idx ? 12 : 0,
              borderBottomRightRadius: projects?.length - 1 === idx ? 12 : 0,
              paddingVertical: 2,
            }}
          >
            <div className="flex flex-row items-center border-r border-r-gray-200 px-2 cursor-pointer w-[50%]">
              {/* Delete Project  */}
              <Tooltip
                title={intl.formatMessage({
                  id: 'REMOVE_PROJECT_FROM_TASK',
                  defaultMessage: 'Remove Project From Task',
                })}
              >
                <div
                  className="py-1 mx-1 align-center flex justify-center"
                  onClick={async () => {
                    setProjects((prevProjects) =>
                      prevProjects?.filter((project) => project?.projectId !== prj?.projectId),
                    );
                    await dispatch(removeTaskFromProjectAction(taskId, prj?.projectId));
                  }}
                >
                  <img
                    className="text-slate-700 cursor-pointer size-2 mr-2"
                    src={'/images/icons/close.svg'}
                    alt="icon"
                  />
                </div>
              </Tooltip>
              <ConnectedProjectIcon projectId={prj.projectId} />
              <div
                className=" text-gray-600 md:text-sm text-xs truncate hover:text-blue-500 hover:underline"
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                onClick={() => {
                  const selectedTask = new URLSearchParams(location.search).get('selectedTask');

                  const id = prj.projectId;
                  let path = `/${id}/${isListView ? 'list' : 'board'}`;

                  if (selectedTask) {
                    path = `/${id}/${isListView ? 'list' : 'board'}?selectedTask=${selectedTask}`;
                  }
                  navigate(path);
                }}
              >
                <ConnectedProjectTitle projectId={prj.projectId} />
              </div>
            </div>
            <div className="truncate px-4 w-[50%]">
              <ConnectedProjectSectionsDropdown projectId={prj.projectId} sectionId={prj.sectionId} taskId={taskId} />
            </div>
          </div>
        );
      })}
    </>
  );
};
